.boxStyled {
  --successScreen-padding: 24px;

  margin-top: calc(var(--successScreen-padding) * -1);
  width: calc(100% + var(--successScreen-padding) * 2);

  @media (--reefer-media-tablet-min) {
    --successScreen-padding: 40px;
  }
}

.background {
  background-color: var(--colors-primary-light);
  height: 100%;
  width: 100%;
}

.background_branded {
  background-color: var(--colors-brand-purple-main);
}

.background_sparkly {
  background-color: transparent;
  background-image: var(--successScreen-sparkly-bg);
  background-size: cover;
}

.themedButton_janePay {
  background-color: var(--colors-brand-purple-main);
  border-color: var(--colors-brand-purple-main);
}
